import React from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

const ChooseCampaign = () => {
  return (
    <>
      <div
        className="modal fade"
        id="CampaignModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content rounded-0">
            <div className="modal-header">
              <h6 className="modal-title" id="exampleModalLabel">
                Choose Campaign Type
              </h6>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body justify-content-center d-flex ">
              <Link className="mr-5" to="/dashboard/campaign-start">
                <button
                  type="button"
                  className="btn btn-primary"
                  data-toggle="modal"
                  data-target="#exampleModal"
                >
                  WhatsApp
                </button>
              </Link>
              <Link to="/dashboard/sms-campaign">
                <button
                  type="button"
                  className="btn btn-primary"
                  data-toggle="modal"
                  data-target="#exampleModal"
                >
                  SMS
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ChooseCampaign;
